export default __webpack_public_path__ + "media/images/carousel/01-f0a2387273692c463f3edf533c38d019.jpg";